// mcc/actionTypes.js

// ── List ─────────────────────────────────────────────────────────────────────
export const GET_MULTICHANNEL_CAMPAIGNS         = "GET_MULTICHANNEL_CAMPAIGNS";
export const GET_MULTICHANNEL_CAMPAIGNS_SUCCESS = "GET_MULTICHANNEL_CAMPAIGNS_SUCCESS";
export const GET_MULTICHANNEL_CAMPAIGNS_FAILURE = "GET_MULTICHANNEL_CAMPAIGNS_FAILURE";

// ── Single ───────────────────────────────────────────────────────────────────
export const GET_MULTICHANNEL_CAMPAIGN         = "GET_MULTICHANNEL_CAMPAIGN";
export const GET_MULTICHANNEL_CAMPAIGN_SUCCESS = "GET_MULTICHANNEL_CAMPAIGN_SUCCESS";
export const GET_MULTICHANNEL_CAMPAIGN_FAILURE = "GET_MULTICHANNEL_CAMPAIGN_FAILURE";

// ── Create ───────────────────────────────────────────────────────────────────
export const CREATE_MULTICHANNEL_CAMPAIGN         = "CREATE_MULTICHANNEL_CAMPAIGN";
export const CREATE_MULTICHANNEL_CAMPAIGN_SUCCESS = "CREATE_MULTICHANNEL_CAMPAIGN_SUCCESS";
export const CREATE_MULTICHANNEL_CAMPAIGN_FAILURE = "CREATE_MULTICHANNEL_CAMPAIGN_FAILURE";

// ── Update ───────────────────────────────────────────────────────────────────
export const UPDATE_MULTICHANNEL_CAMPAIGN         = "UPDATE_MULTICHANNEL_CAMPAIGN";
export const UPDATE_MULTICHANNEL_CAMPAIGN_SUCCESS = "UPDATE_MULTICHANNEL_CAMPAIGN_SUCCESS";
export const UPDATE_MULTICHANNEL_CAMPAIGN_FAILURE = "UPDATE_MULTICHANNEL_CAMPAIGN_FAILURE";

// ── Delete ───────────────────────────────────────────────────────────────────
export const DELETE_MULTICHANNEL_CAMPAIGN         = "DELETE_MULTICHANNEL_CAMPAIGN";
export const DELETE_MULTICHANNEL_CAMPAIGN_SUCCESS = "DELETE_MULTICHANNEL_CAMPAIGN_SUCCESS";
export const DELETE_MULTICHANNEL_CAMPAIGN_FAILURE = "DELETE_MULTICHANNEL_CAMPAIGN_FAILURE";

// ── Trigger ──────────────────────────────────────────────────────────────────
export const TRIGGER_CAMPAIGN_PROCESS         = "TRIGGER_CAMPAIGN_PROCESS";
export const TRIGGER_CAMPAIGN_PROCESS_SUCCESS = "TRIGGER_CAMPAIGN_PROCESS_SUCCESS";
export const TRIGGER_CAMPAIGN_PROCESS_FAILURE = "TRIGGER_CAMPAIGN_PROCESS_FAILURE";

// ── UI / shared ──────────────────────────────────────────────────────────────
export const SET_LOADING               = "MCC_SET_LOADING";
export const SET_ERRORS                = "MCC_SET_ERRORS";
export const SET_FILTERS               = "MCC_SET_FILTERS";
export const SET_OPEN_MODAL            = "MCC_SET_OPEN_MODAL";
export const SET_MULTICHANNEL_CAMPAIGN = "SET_MULTICHANNEL_CAMPAIGN";

// ── Acefone lead-list dropdown ───────────────────────────────────────────────
export const FETCH_ACEFONE_LEAD_LISTS         = "FETCH_ACEFONE_LEAD_LISTS";
export const FETCH_ACEFONE_LEAD_LISTS_SUCCESS = "FETCH_ACEFONE_LEAD_LISTS_SUCCESS";
export const FETCH_ACEFONE_LEAD_LISTS_FAILURE = "FETCH_ACEFONE_LEAD_LISTS_FAILURE";

// ── Retry campaign output (polling) ──────────────────────────────────────────
export const RETRY_CAMPAIGN_OUTPUT         = "RETRY_CAMPAIGN_OUTPUT";
export const RETRY_CAMPAIGN_OUTPUT_SUCCESS = "RETRY_CAMPAIGN_OUTPUT_SUCCESS";
export const RETRY_CAMPAIGN_OUTPUT_FAILURE = "RETRY_CAMPAIGN_OUTPUT_FAILURE";

// ── Polling control ───────────────────────────────────────────────────────────
// Dispatched by the saga after trigger success to signal the context to begin
// polling immediately. Cleared by the context after consuming.
export const START_CAMPAIGN_POLLING    = "START_CAMPAIGN_POLLING";
export const CLEAR_PENDING_POLLING_IDS = "CLEAR_PENDING_POLLING_IDS";

export const TRIGGER_MCC_SERVICE = "TRIGGER_MCC_SERVICE";
export const TRIGGER_MCC_SERVICE_SUCCESS = "TRIGGER_MCC_SERVICE_SUCCESS";
export const TRIGGER_MCC_SERVICE_FAILURE = "TRIGGER_MCC_SERVICE_FAILURE";